module.exports = __webpack_public_path__ + "img/1490499019.b6ee8663.jpg";